import React, {useState, useContext, useEffect} from 'react';
import { IonMenu, IonHeader, IonToolbar, IonTitle, IonButtons, IonMenuButton, IonContent, IonList, IonMenuToggle, IonItem, IonLabel } from '@ionic/react';
import { useHistory} from "react-router-dom";

import { Auth_Zasava_Context } from '../storeState/Auth_Zasava_Context';

export function SideMenu (props) {

    let zasava_context = useContext(Auth_Zasava_Context);

    const [sessionID, setSessionID ] = useState(zasava_context.sessionID);
    let [baseURL, setBaseURL ] = useState(zasava_context.baseURL);

    const [acctID, setAcctID ] = useState(zasava_context.acctID);
    const [schema, setSchemaName] = useState(zasava_context.schema);
    
    let history = useHistory();


    function handleRoute(event)
    {
        //alert(authenticatedMerchent_context.authenticated);

        history.push(event);
        window.location.pathname = event;

    }


        return (
               // <IonRouterOutlet>
                    //<IonMenu contentId='qavaAppConfirmed' side='end'>
                    <React.Fragment>
                        {zasava_context.accessRights != null &&
                         <IonMenu menuId="first" contentId={props.contentId} type={props.type} side='end'>
                            <IonHeader>
                                <IonToolbar> 
                                    <IonTitle>
                                        Menu
                                    </IonTitle>
                                    <IonButtons slot='end'>
                                        <IonMenuButton autoHide='false'></IonMenuButton>
                                    </IonButtons>
                                </IonToolbar>
                            </IonHeader>
                            <IonContent>
                                <IonList>
                                        <IonMenuToggle auto-hide='false'>
                                             <IonItem button onClick={() => handleRoute('/' )}>
                                                    <IonLabel>Home</IonLabel>
                                                </IonItem>
                                        </IonMenuToggle>
                                        <IonMenuToggle auto-hide='false' >
                                                <IonItem button onClick={() => handleRoute('/zasava_profileSetting' )}>
                                                    <IonLabel>Profile</IonLabel>
                                                </IonItem>
                                        </IonMenuToggle>
                                        <IonMenuToggle auto-hide='false' >
                                                <IonItem button onClick={() => handleRoute('/zasava_accountSetting' )}>
                                                    <IonLabel>Account</IonLabel>
                                                </IonItem>
                                        </IonMenuToggle>
                                        <IonMenuToggle auto-hide='false'>
                                                <IonItem button onClick={() => handleRoute('/logout' )}>
                                                    <IonLabel>Logout</IonLabel>
                                                </IonItem>
                                        </IonMenuToggle>
                                </IonList>                
                            </IonContent>
                        </IonMenu>}
                    </React.Fragment>
                //</IonRouterOutlet>
        )
    }


    export function Employee_SideMenu () {

        let employee_context = useContext(Auth_Zasava_Context);
    
    
        const [acctID, setAcctID ] = useState(employee_context.acctID);
        const [schema, setSchemaName] = useState(employee_context.schema);
        
    
            return (
                   // <IonRouterOutlet>
                        <IonMenu contentId='qavaAppConfirmed' side='end'>
                            <IonHeader>
                                <IonToolbar> 
                                    <IonTitle>
                                        Menu
                                    </IonTitle>
                                    <IonButtons slot='end'>
                                        <IonMenuButton autoHide='false'></IonMenuButton>
                                    </IonButtons>
                                </IonToolbar>
                            </IonHeader>
                            <IonContent>
                                <IonList>
                                        <IonMenuToggle auto-hide='false'>
                                                <IonItem button routerLink='/ims/hotel_merchantMainPageApp'>
                                                    <IonLabel>Home</IonLabel>
                                                </IonItem>
                                        </IonMenuToggle>
                                        <IonMenuToggle auto-hide='false'>
                                                <IonItem button routerLink='/ims/hotel_profileSetting'>
                                                    <IonLabel>Profile</IonLabel>
                                                </IonItem>
                                        </IonMenuToggle>
                                        <IonMenuToggle auto-hide='false' >
                                                <IonItem button routerLink='/ims/hotel_accountSetting'>
                                                    <IonLabel>Account</IonLabel>
                                                </IonItem>
                                        </IonMenuToggle>
                                        <IonMenuToggle auto-hide='false' >
                                                <IonItem button routerLink='/ims/hotel_management'>
                                                    <IonLabel>Management</IonLabel>
                                                </IonItem>
                                        </IonMenuToggle>
                                        <IonMenuToggle auto-hide='false' >
                                                <IonItem button routerLink='/ims/hotel_productList'>
                                                    <IonLabel>Product List</IonLabel>
                                                </IonItem>
                                        </IonMenuToggle>
                                        <IonMenuToggle auto-hide='false'>
                                                <IonItem button routerLink='/ims/logout'>
                                                    <IonLabel>Logout</IonLabel>
                                                </IonItem>
                                        </IonMenuToggle>
                                </IonList>                
                            </IonContent>
                        </IonMenu>
                    //</IonRouterOutlet>
            )
        }